import { useQuery } from '@tanstack/react-query';

import { LinkReport } from '../types';

import { axios } from '@/libraries/axios';
import { ExtractFnReturnType, QueryConfig } from '@/libraries/react-query';

export const getDeviceTrackerReport = (): Promise<LinkReport[]> => {
  return axios.get('/device-tracker/report');
};

type QueryFnType = typeof getDeviceTrackerReport;

type UseGetDeviceTrackerReportOptions = {
  config?: QueryConfig<QueryFnType>;
};

export const useGetDeviceTrackerReport = ({
  config = {},
}: UseGetDeviceTrackerReportOptions = {}) => {
  return useQuery<ExtractFnReturnType<QueryFnType>>({
    ...config,
    queryKey: ['device-tracker', 'report'],
    queryFn: () => getDeviceTrackerReport(),
    refetchInterval: 15000,
  });
};
